export const DividerProperty = {
  ClassName: 'className',
  Orientation: 'orientation',
};

export const FlexDirection = {
  Row: 'row',
  Column: 'column',
};
